<template>
  <div class="sn-f-b-s article">
    <sn-navigator id="JKJT" :initial="perpetual.FUNCTION_ID_ZJJT"></sn-navigator>
    <div class="sn-f-1 sn-f-col-b-s article-region">
      <sn-breadcrumb :breadcrumb="[{ title: '首页' }, { title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_ZJJT), router: '/lecture/homepage' }, { title: '文章详情' }]"></sn-breadcrumb>
      <div class="sn-f-1 article-blank">
        <template v-if="!$sn.validate.empty(article)">
          <div class="article-head">
            <div class="sn-f-c-c sn-fc-text1 sn-fs-28 sn-fw-bold" v-if="article.title">{{article.title}}</div>
            <div class="sn-f-c-c article-sub-title" v-if="article.lecturerName || article.applicablePeople || article.createdDate">
              <div class="sn-ph-10" v-if="article.lecturerName">讲师：{{article.lecturerName}}</div>
              <div v-if="article.applicablePeople">适用人群：{{article.applicablePeople}}</div>
              <div class="sn-ph-10" v-if="article.createdDate">发布时间：{{article.createdDate}}</div>
            </div>
          </div>
          <div class="article-content" v-html="article.description"></div>
        </template>
        <sn-no-data v-else></sn-no-data>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Constants from '@/common/utils/constants';

export default {
  data() {
    return {
      perpetual: Constants,
      article: {}
    };
  },
  computed: {},
  watch: {},
  created: function() {
    document.title = '文章详情';
    this.$route.meta.title = '文章详情';
    if (this.$route.query.id) this.initialArticle(this.$route.query.id);
  },
  methods: {
    // 获取文章
    initialArticle(id) {
      const params = {
        url: this.$sn.format.caption(Swagger.getLectureArticleDetail, [id]),
        query: {}
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) this.article = result.data;
        else this.$sn.assembly.toast({ caption: result && result.msg ? result.msg : Messages.C001 });
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.article {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .article-blank {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      padding: 20px 20px 0;

      .article-head {
        .article-sub-title {
          @include fs(16);

          color: $text6;
          margin-top: 5px;
        }
      }

      .article-content {
        flex: 1;
        overflow-y: auto;
        margin: 12px 0 20px;
      }
    }
  }
}
</style>
